import React from "react";
import {
  CartVariation,
  isHexColor,
  normalizeVariationValue,
} from "../../utils/cartVariation";

type CartVariationDisplayProps = {
  variation?: CartVariation | null;
  className?: string;
};

export default function CartVariationDisplay({
  variation,
  className = "",
}: CartVariationDisplayProps) {
  const couleur = normalizeVariationValue(variation?.couleur);
  const taille = normalizeVariationValue(variation?.taille);

  if (!couleur && !taille) return null;

  return (
    <div
      className={`cart-variation-display product-category-name mb-0 d-flex align-items-center gap-2 flex-wrap ${className}`.trim()}
    >
      {couleur ? (
        <span className="cart-variation-color d-inline-flex align-items-center gap-1">
          <span>Couleur :</span>
          {isHexColor(couleur) ? (
            <span
              className="cart-variation-color__swatch"
              style={{ backgroundColor: couleur }}
              title={couleur}
              aria-label={`Couleur sélectionnée ${couleur}`}
            />
          ) : (
            <span>{couleur}</span>
          )}
        </span>
      ) : null}
      {couleur && taille ? (
        <span className="cart-variation-separator" aria-hidden="true">
          ·
        </span>
      ) : null}
      {taille ? <span>Taille : {taille}</span> : null}
    </div>
  );
}
